module.exports = __webpack_public_path__ + "static/joette-borzik-44a2edf61b0c60017d0203c79936efac.jpg";